export default __webpack_public_path__ + "static/media/banner_2.1936f30e.jpg";